const video = {
	el: {
		heroVideoContainer: document.querySelector('.js-hero-video')
	},

	fxFetchVideo (video) {
		fetch(video.querySelector('source').src)
			.then(response => {
				response.blob()
			})
			.then(blob => {
				video.srcObject = blob
				return video.play()
			})
			.catch(error => {
				console.log(error)
			})
	},

	fxGetProfile () {
		const params = window.location?.search

		if(params.includes('profile')) {
			const profile = params.includes('&') ? params.split('&')[0].split('=')[1] : params.split('=')[1]
			return profile
		}
	},

	fxSetVideoParamsAndPlay(tag, title, text, poster, video) {

		const pathToProd = window.location.pathname.includes('/campanhas/impostos-simples') ? '/campanhas/impostos-simples' : ''

		const heroTag = this.el.heroVideoContainer.querySelector('.hero__tag'),
			heroTitle = this.el.heroVideoContainer.querySelector('.hero__title'),
			heroText = this.el.heroVideoContainer.querySelector('.hero__text'),
			heroVideo = this.el.heroVideoContainer.querySelector('.hero__video'),
			heroVideoSrc = heroVideo.querySelector('source')
		
		heroTag.textContent = tag.split('=')[1]
		heroTitle.textContent = title.split('=')[1]
		heroText.textContent = text.split('=')[1]
		heroVideo.setAttribute('poster', `${pathToProd}/assets/img/misc/${poster.split('=')[1]}.jpg`)
		heroVideoSrc.src = `${pathToProd}/assets/video/${video.split('=')[1]}.mp4`

		heroVideo.load()

		this.fxFetchVideo(heroVideo)
	},

	fxRenderVideo() {
		const profiles = this.el.heroVideoContainer.dataset.profiles,
			profilesArray = new Array(... profiles.split('&')),
			heroTag = this.el.heroVideoContainer.querySelector('.hero__tag'),
			heroTitle = this.el.heroVideoContainer.querySelector('.hero__title'),
			heroText = this.el.heroVideoContainer.querySelector('.hero__text'),
			heroVideo = this.el.heroVideoContainer.querySelector('.hero__video'),
			lastProfileArray = profilesArray.slice(-1),
			lastProfile = lastProfileArray[0],
			lastProfileID = Number(lastProfile.split(';')[0].split('=')[1]),
			defaultProfile = profilesArray[0],
			profileIDS = profilesArray.map(profile => profile.split(';')[0].split('=')[1]),
			hasId = (array, id) => array.some(arrayId => arrayId === id)

		//-console.log(!hasId(profileIDS, this.fxGetProfile()))

		//no params on url
		if(!hasId(profileIDS, this.fxGetProfile()) || !window.location.search.includes('profile')) {
			const [profID, tag, title, text, poster, video, hub] = defaultProfile.split(';')
	
			this.fxSetVideoParamsAndPlay(tag, title, text, poster, video)
			cookieHub.fxSetCookieHub(hub.split('=')[1])
		} else {
			for (const profile of profilesArray) {
				const [profID, tag, title, text, poster, video, hub] = profile.split(';')
				
				if(profID.split('=')[1] === this.fxGetProfile()) {
					this.fxSetVideoParamsAndPlay(tag, title, text, poster, video)
					cookieHub.fxSetCookieHub(hub.split('=')[1])
				}
			}
		}
	},

	init() {
		if(!this.el.heroVideoContainer) return
		this.fxRenderVideo()
	}
}

video.init()